import React, {useState, Fragment} from 'react';
import { Card, CardContent, } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado} from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';

const EditarDatosDeTelevision = ({title, openFullScreenDialog, handleClose, datossDelTarifario, accionRegistroEditado}) => {
    const dispatch = useDispatch();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeError: 'error', tipoDeMensaje: '', abrirRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);

    const {
        numeroDelCanal, canalDeTercero,
        medioDeComunicacion: {
            nombre, logo, nit_empresa,
            detallesDeMedioDeComunicacion:{
                descripcion, correoDeRecepcion, diasDeAnticipacion, especTecnicasDelMaterial, porcentajeAudienciaHombres,
                porcentajeAudienciaMujeres, nivelSocioEconomicoAlto, nivelSocioEconomicoMedio, nivelSocioEconomicoBajo,
                ratingDelMedio, alcanceEnPersonas,
            },
        }
    } = datossDelTarifario;

    const [elementosDelFormulario] = React.useState({
        tituloDatosDelCanal:{
            idelement: "tituloDatosDelCanal", title:'Datos del canal', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloDatosDelCanal", value: "", isError:false,
        },
        nombreDelCanal: {
            idelement: "nombreDelCanal",  value: nombre, label: "Nombre del canal *", pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.#_“”()-*_/@]{4,100}$", validators: ['required'], errorMessages:['El campo es requerido, sin espacios al inicio y final'], isError:false, elementType:'texto', name:"nombreDelCanal", 'disabled': false, width: '33%'
        },
        numeroDelCanal: {
            idelement: "numeroDelCanal",  value: numeroDelCanal, label: "Número del canal *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"numeroDelCanal", 'disabled': false, width: '33%'
        },
        logoCanal:{
            idelement: "logoCanal", value: logo ? logo.includes('base64,') ? logo : `data:image/jpeg;base64,${logo}` : "", label: "LOGO", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"logoCanal", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '33%', type: "file"
        },
        descripcionCanal:{
            idelement: "descripcionCanal", value: descripcion, label: `Descripción del canal`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "descripcionCanal", width: '100%'
        },
        tituloEspecificaciones:{
            idelement: "tituloEspecificaciones", title:'Especificaciones Técnicas', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloEspecificaciones", value: "", isError:false,
        },
        correoElectronico: {
          idelement: "correoElectronico", value: correoDeRecepcion, label: "Correo electrónico para recepción de materiales *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico", width: "50%"
        },
        diasDeAnticipacion: {
            idelement: "diasDeAnticipacion",  value: diasDeAnticipacion, label: "Días de anticipación para entregar el material a pautar *", pattern:"^[0-9]{1,5}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"diasDeAnticipacion", 'disabled': false, width: "50%"
        },
        comentarioEspecificaciones:{
            idelement: "comentarioEspecificaciones", value: especTecnicasDelMaterial, label: `Especificaciones técnicas del material`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "comentarioEspecificaciones", width: '100%'
        },
        tituloRegistroPrograma:{
            idelement: "tituloRegistroPrograma", title:'Registro de programas que se transmite en un canal tercero', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloRegistroPrograma", value: "", isError:false,
        },
        estaRegistrandoCanal:{
          idelement: "estaRegistrandoCanal", value: canalDeTercero ? 1 : 2, label: "¿Esta registrando programas que se transmite en un tercero? *", isError:false, elementType:'radio', errorMessages:['Debe marcar una opción'], options : [ { value: 1, label: 'SI' }, { value: 2, label: 'NO' }], 'disabled':true, isRequired: true,
        },
        ratingAlcanceTitulo:{
            idelement: "ratingAlcanceTitulo", title:'RATING Y ALCANCE', position:"center", elementType:'titulo', showTitleForm: true, name: "ratingAlcanceTitulo", value: "", isError:false,
        },
        ratingCanal: {
            idelement: "ratingCanal",  value: ratingDelMedio, label: `Ingrese el rating *`,pattern:"^\\d+(.[0-9]{2})?$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"ratingCanal", 'disabled': false, width: '30%',
        },
        alcancePersonas: {
            idelement: "alcancePersonas",  value: alcanceEnPersonas, label: "Ingrese el alcance en personas *", pattern:"^[0-9]{1,11}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"alcancePersonas", 'disabled': false, width: '30%'
        },
        perfilAudenciaTitulo:{
            idelement: "perfilAudenciaTitulo", title:'PERFIL DE LA AUDIENCIA EXPUESTA', position:"center", elementType:'titulo', showTitleForm: true, name: "perfilAudenciaTitulo", value: "", isError:false,
        },
        generoTitulo:{
            idelement: "generoTitulo", title:'GÉNERO', position:"center", elementType:'titulo', showTitleForm: true, name: "generoTitulo", value: "", isError:false, widthTitleForm:'80%'
        },
        alertaGenero:{
            idelement: "alertaGenero", mensaje:'EL PORCENTAJE DE GENERO DISTRIBUIDO DEBE SUMAR 100%.', elementType:'alerta', showAlertForm: true, name: "alertaGenero", value: "", isError:false, severity: 'error', width:'80%'
        },
        hombres: {
            idelement: "hombres",  value: porcentajeAudienciaHombres, label: "Hombres % *", pattern:"^[0-9]{1,3}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"hombres", 'disabled': false, width: '30%',
        },
        mujeres: {
            idelement: "mujeres",  value: porcentajeAudienciaMujeres, label: "Mujeres % *", pattern:"^[0-9]{1,3}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"mujeres", 'disabled': false, width: '30%',
        },
        nivelSocieconomicoTitulo:{
            idelement: "nivelSocieconomicoTitulo", title:'NIVEL SOCIOECONÓMICO', position:"center", elementType:'titulo', showTitleForm: true, name: "nivelSocieconomicoTitulo", value: "", isError:false, widthTitleForm:'80%'
        },
        alertaNivelSociecomico:{
            idelement: "alertaNivelSociecomico", mensaje:'EL PORCENTAJE DE NIVEL SOCIOECONÓMICO DISTRIBUIDO DEBE SUMAR 100%.', elementType:'alerta', showAlertForm: true, name: "alertaNivelSociecomico", value: "", isError:false, severity: 'error', width:'80%'
        },
        alto: {
            idelement: "alto",  value: nivelSocioEconomicoAlto, label: "Alto % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"alto", 'disabled': false, width: '27%',
        },
        medio: {
            idelement: "medio",  value: nivelSocioEconomicoMedio, label: "Medio % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"medio", 'disabled': false, width: '27%'
        },
        bajo: {
            idelement: "bajo",  value: nivelSocioEconomicoBajo, label: "Bajo % *", pattern:"^[0-9]{1,2}$", validators: ['required'], errorMessages:['El campo es requerido  y solo números'], isError:false, elementType:'texto', name:"bajo", 'disabled': false, width: '26%'
        },
        acciones:{
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const guardarDatos = async (datosDelFormulario) => {
        const {
            nombreDelCanal, numeroDelCanal, logoCanal, descripcionCanal, correoElectronico, diasDeAnticipacion,
            comentarioEspecificaciones, estaRegistrandoCanal, ratingCanal, alcancePersonas, hombres, mujeres, alto, medio, bajo
        } = datosDelFormulario;

        const objetoAEnviar = {
            "idMedioDeComunicacion": datossDelTarifario.medioDeComunicacion?.id,
            "nitEmpresa": nit_empresa,
            canalDeTercero: Number(estaRegistrandoCanal) === 1,
            datosDemograficos: {
                "alcanceEnPersonas": alcancePersonas,
                "nivelSocioEconomicoAlto": alto,
                "nivelSocioEconomicoBajo": bajo,
                "nivelSocioEconomicoMedio": medio,
                "porcentajeAudienciaHombres": hombres,
                "porcentajeAudienciaMujeres": mujeres,
                "ratingDelMedio": ratingCanal
            },
            descripcion: descripcionCanal,
            logo: logoCanal,
            nombreDelCanal,
            numeroDelCanal,
            recepcionDeMateriales: {
                correoDeRecepcion: correoElectronico,
                diasDeAnticipacion: Number(diasDeAnticipacion),
                especificacionesTecnicasDelMaterial: comentarioEspecificaciones
            }
        }

        setcargandoSolicitud(true);

        const datosAEnviar = { controller: "tarifarioDeMediosTelevisivos", action: "editar", data: objetoAEnviar, nombreDelMetodo: "editar/informacionGeneral" };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        setcargandoSolicitud(false);

        if(respuesta?.error) return setDatosDeRespuesta({ tipoDeError: 'error', tipoDeMensaje: respuesta?.error?.message || "Ocurrió un inconveniente, Intente de nuevo!", abrirRespuesta: true, });
        accionRegistroEditado(respuesta?.data)
    }

    const [listadoDeBotones]= React.useState({
        "guardarDatos":{"label":"Guardar Datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const cerrarAlerta = (_, reason) => {
        if (reason === 'clickaway') {return}
        setDatosDeRespuesta({ tipoDeError: 'error', tipoDeMensaje: "", abrirRespuesta: false, });
    };

    const { tipoDeError, tipoDeMensaje, abrirRespuesta} = datosDeRespuesta;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            fullscreen={true}
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={tipoDeError} content={tipoDeMensaje} open={abrirRespuesta} handClose={cerrarAlerta}/>
                <Card>
                    <CardContent>
                        <Formulario
                            elements={elementosDelFormulario}
                            buttonList={listadoDeBotones}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default EditarDatosDeTelevision;